module.exports = __webpack_public_path__ + "img/boxed-18.212a0c85.jpg";